import { shiftDateKey } from '@apps/web/lib/date_utils';

export const AGENT_NOTE_RANGE_PRESETS = [
    'today',
    '7d',
    '14d',
    '30d',
    '90d',
    'ytd',
] as const;
export type AgentNoteRangePreset = (typeof AGENT_NOTE_RANGE_PRESETS)[number];

export type RangeSelection =
    | { readonly kind: 'all' }
    | { readonly kind: 'preset'; readonly preset: AgentNoteRangePreset }
    | { readonly kind: 'fixed'; readonly from: string; readonly to: string };

export const RANGE_PRESET_LABELS: Record<AgentNoteRangePreset, string> = {
    today: 'Today',
    '7d': 'Last 7 days',
    '14d': 'Last 14 days',
    '30d': 'Last 30 days',
    '90d': 'Last 90 days',
    ytd: 'Year to date',
};

/**
 * Resolve a relative range preset to inclusive date keys, anchored on the
 * given today (analytics-timezone date key). Presets stay relative in the
 * URL so a pinned view keeps meaning "the last N days".
 */
export function resolveRangePreset(
    preset: AgentNoteRangePreset,
    today: string,
): { readonly from: string; readonly to: string } {
    switch (preset) {
        case 'today':
            return { from: today, to: today };
        case '7d':
            return { from: shiftDateKey(today, -6), to: today };
        case '14d':
            return { from: shiftDateKey(today, -13), to: today };
        case '30d':
            return { from: shiftDateKey(today, -29), to: today };
        case '90d':
            return { from: shiftDateKey(today, -89), to: today };
        case 'ytd':
            return { from: `${today.slice(0, 4)}-01-01`, to: today };
        default: {
            const exhaustive: never = preset;
            throw new Error(`Unhandled range preset: ${String(exhaustive)}`);
        }
    }
}
